export enum SessionStatus {
    Valid, // < 21 days old
    Stale, // <= 21 days old
    Expired, // >= 22 days old
}
